import { Avatar, Dialog, DialogActions, DialogContent, Divider, Fab, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import Ws from '../../providers/Ws';
import avatar from '../../Pics/avatar.jpg'
import Utils from '../../providers/Utils';
import FileIcon from '../../providers/FileIcon';


export default class PopUpAplicatie extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }

    u = new Utils()


    numeAvatar = (nume) => {

        if(nume){
            let n = nume.split(' ')

            // console.log('n :>> ', n);
    
            let firstLetters = ''
    
            if (n[0]) {
    
                firstLetters += n[0].substring(0, 1)
    
            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }
    
            firstLetters = firstLetters.toUpperCase()
    
            return firstLetters
        }else{
            return 'NA'
        }
        

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    maxWidth='md'
                    open={this.props.open}
                    onClose={this.props.dialogClose}>
                    <DialogActions >
                    <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>

                    <DialogContent>
                        <Grid style={{ marginTop: 40 }} container>
                            <Grid style={{ marginBottom: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                        <Grid container>

                                            <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                {
                                                    this.props.angajat.poza &&
                                                    <div
                                                        className='pm-angajati-picture'

                                                        style={{ backgroundImage: `url('${this.props.angajat.poza ? (new Ws().adresaMedia + '/Angajati/' + this.props.angajat.poza) : avatar}')`, width: 48, height: 48, padding: 5 }}>

                                                    </div>
                                                }
                                                {!this.props.angajat.poza &&

                                                    <Avatar
                                                        className='pm-angajati-picture'
                                                        style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', height: 48, width: 48, backgroundColor: new Utils().culoriUtilizatori(this.props.angajat.id), padding: 5, cursor: 'pointer' }}>
                                                        {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                                        <span style={{ display: 'block' }}>{this.numeAvatar(this.props.angajat.nume)} </span>
                                                    </Avatar>
                                                    // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                }
                                            </Grid>

                                            <Grid style={{ textAlign: 'left', paddingTop: 10, paddingLeft: 20 }} item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                <span style={{ fontWeight: 700, fontSize: 30 }}>    {this.props.angajat.nume}</span><br />

                                            </Grid>

                                        </Grid>
                                    </Grid>
                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                        <span style={{ display: 'block', marginBottom: 10, color: 'black' }}><span style={{ color: 'rgb(176 176 176)' }}>{this.dictionary.pontaje.functie}:</span>{this.props.angajat.functie}</span>
                                        <span style={{ display: 'block', color: 'black' }}><span style={{ color: 'rgb(176 176 176)' }}>{this.dictionary.pontaje.departament}:</span>{this.props.angajat.departament}</span>

                                    </Grid>


                                    <Divider style={{ marginTop: 20, marginBottom: 20 }} className="pm-divider" />
                                </Grid>


                            </Grid>


                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingTop: 10, marginTop: 0, color: 'rgb(100	100	100)' }} > {this.dictionary.monitorizare.folosireAplicatie} {this.props.aplicatie.nume}</h5>

                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container>
                                            <Grid style={{ textAlign: 'left' }} item xs={10} sm={10} md={10} lg={10} xl={10}>
                                                <span style={{ fontWeight: 600, fontSize: 14 }}> {this.dictionary.monitorizare.denumire}   </span>
                                            </Grid>
                                            <Grid style={{ textAlign: 'right' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                <span style={{ fontWeight: 600, fontSize: 14 }}> {this.dictionary.monitorizare.timp}   </span>

                                            </Grid>
                                        </Grid>

                                    </Grid>

                                    <Grid style={{marginTop:20}} item item xs={12} sm={12} md={12} lg={12} xl={12} >

                                        {this.props.angajat.aplicatii_folosite_merged.filter(aa => aa.app_id === this.props.aplicatie.hash_id).map((app, idx) => {

                                            return (
                                                <Grid key={idx} container>
                                                    <Grid style={{ textAlign: 'left' }} item xs={10} sm={10} md={10} lg={10} xl={10}>

                                                        <div style={{ marginBottom: 20 }} key={idx}>

                                                            <div
                                                                style={{ display: 'inline-block', marginRight: 20, verticalAlign: 'middle' }}
                                                            >
                                                                <FileIcon
                                                                    width={30}
                                                                    height={30}
                                                                    fileName={this.props.aplicatie} />

                                                            </div>

                                                            <span style={{ fontWeight: 500, fontSize: 14 }}>    {app.details.length > 100 ? app.details.substring(0, 90) + '...' : app.details}</span><br />

                                                        </div>
                                                    </Grid>

                                                    <Grid style={{ textAlign: 'right' }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                    <span style={{ fontWeight: 500, fontSize: 14 }}>    {this.u.secondsToMinute(app.seconds_used)}</span>
                                                    </Grid>
                                                </Grid>
                                            )

                                        })}
                                    </Grid>

                                </Grid>
                            </Grid>



                        </Grid>
                    </DialogContent>


                </Dialog>
            </div>
        );
    }
}